/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  BotState
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';



// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type wallEPushBotStateResponse200 = {
  data: void
  status: 200
}

export type wallEPushBotStateResponseSuccess = (wallEPushBotStateResponse200) & {
  headers: Headers;
};
;

export type wallEPushBotStateResponse = (wallEPushBotStateResponseSuccess)

export const getWallEPushBotStateUrl = () => {




  return `/api/WallE/state`
}

export const useWallEPushBotStateHook = (): (botState?: NonReadonly<BotState>, options?: RequestInit) => Promise<wallEPushBotStateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botState?: NonReadonly<BotState>, options?: RequestInit) => {

        return customFetcher(getWallEPushBotStateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botState)
  }
);
      }
  }


